module.exports = __webpack_public_path__ + "img/legume-edamame-350x184.a730f67f.jpg";